import React, { useState, useEffect } from 'react';
import dayjs from 'dayjs';
import { Form, Col, DatePicker, Space } from 'antd';

import {
  ShopStore,
  CurrentUserStore,
  InspectionsStore,
  UserStore,
} from 'stores';

const CreatedAt = ({ form }) => {
  return (
    <Col span={12}>
      <Form.Item
        label="Created At"
        required
        name="createdAt"
        rules={[{ required: true, message: 'Created At is required' }]}
        style={{ marginBottom: 10 }}
        initialValue={dayjs()}
      >
        <DatePicker style={{ width: '100%' }} showTime />
      </Form.Item>
    </Col>
  );
};

export default CreatedAt;
